import { Box, Button, InputAdornment, TextField } from "@mui/material";
import { Field, Form, Formik } from "formik";
import React from "react";
import { FIELD_ORDER } from "./commodityInitial";
import AccountTypeSelect from "./component/AccountTypeSelect";
import BankBranchSelect from "./component/BankBranchSelect";
import BankSelect from "./component/BankSelect";
import ClosingDateGroupSelect from "./component/ClosingDateGroupSelect";
import CommodityOwnerTotalDivisionSelect from "./component/CommodityOwnerTotalDivisionSelect";
import CustomSection from "./component/CustomSection";
import SalesRecordTypeSelect from "./component/SalesRecordTypeSelect";
import useKeyboardNavigation from "./useKeyboardNavigation";
import { validationSchema } from "./validationSchema";
import InvoiceRegistrationHistoryForm from "./component/InvoiceRegistrationHistoryForm";
import AreaCdSelect from "./component/AreaCdSelect";

const CommodityOwnerNewForm = (props) => {
  const { innerRef, commodityOwnerInfo, isUpdateMode, refs } = props;
  const { moveNext, movePrevious } = useKeyboardNavigation(refs, FIELD_ORDER);

  const clearBankInfo = (setFieldValue) => {
    setFieldValue("accountName", "");
    setFieldValue("accountNumber", "");
    setFieldValue("accountTypeCd", -1);
    setFieldValue("bankBranchCd", -1);
    setFieldValue("bankCd", -1);
    setFieldValue("bankAccountId", -1);
  };

  return (
    <Formik
      innerRef={innerRef}
      initialValues={commodityOwnerInfo}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={(values) => {
        alert(JSON.stringify(values, null, 2));
      }}
    >
      {({ errors, touched, handleChange, handleSubmit, setFieldValue, values }) => (
        <Form onSubmit={handleSubmit}>
          <CustomSection title="荷主">
            <Field
              name="commodityOwnerCd"
              as={TextField}
              label="荷主コード"
              error={
                touched.commodityOwnerCd && Boolean(errors.commodityOwnerCd)
              }
              helperText={touched.commodityOwnerCd && errors.commodityOwnerCd}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              required
              id={`commodity-owner-field-commodityOwnerCd`}
              sx={{ width: 150 }}
              inputRef={refs.current["commodityOwnerCd"]}
              disabled={isUpdateMode}
              placeholder="数値のみ"
            />
            <Field
              name="commodityOwnerName"
              as={TextField}
              label="荷主名"
              error={
                touched.commodityOwnerName && Boolean(errors.commodityOwnerName)
              }
              helperText={
                touched.commodityOwnerName && errors.commodityOwnerName
              }
              InputLabelProps={{
                shrink: true,
              }}
              required
              onChange={handleChange}
              sx={{ width: 400 }}
              inputRef={refs.current["commodityOwnerName"]}
            />
            <Field
              name="commodityOwnerNameFurigana"
              as={TextField}
              label="荷主フリガナ"
              error={
                touched.commodityOwnerNameFurigana &&
                Boolean(errors.commodityOwnerNameFurigana)
              }
              helperText={
                touched.commodityOwnerNameFurigana &&
                errors.commodityOwnerNameFurigana
              }
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleChange}
              sx={{ width: 400 }}
              inputRef={refs.current["commodityOwnerNameFurigana"]}
            />
          </CustomSection>

          <CustomSection title="住所">
            <Field
              name="postCode"
              as={TextField}
              label="郵便番号"
              error={touched.postCode && Boolean(errors.postCode)}
              helperText={touched.postCode && errors.postCode}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">〒</InputAdornment>
                ),
              }}
              id={`commodity-owner-field-postCode`}
              sx={{ width: 150 }}
              placeholder="7桁「-」なし"
              inputRef={refs.current["postCode"]}
            />
            <Field
              name="address"
              as={TextField}
              label="住所"
              error={touched.address && Boolean(errors.address)}
              helperText={touched.address && errors.address}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              id={`commodity-owner-field-address`}
              sx={{ width: 400 }}
              inputRef={refs.current["address"]}
            />
          </CustomSection>

          <CustomSection title="連絡先">
            <Field
              name="tel"
              as={TextField}
              label="電話番号"
              error={touched.tel && Boolean(errors.tel)}
              helperText={touched.tel && errors.tel}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              id={`commodity-owner-field-tel`}
              sx={{ width: 150 }}
              placeholder="数値と(-)のみ"
              inputRef={refs.current["tel"]}
            />
            <Field
              name="fax"
              as={TextField}
              label="FAX番号"
              error={touched.fax && Boolean(errors.fax)}
              helperText={touched.fax && errors.fax}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              id={`commodity-owner-field-fax`}
              sx={{ width: 150 }}
              placeholder="数値と(-)のみ"
              inputRef={refs.current["fax"]}
            />
            <Field
              name="email"
              as={TextField}
              label="メールアドレス"
              error={touched.email && Boolean(errors.email)}
              helperText={touched.email && errors.email}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              id={`commodity-owner-field-email`}
              sx={{ width: 400 }}
              inputRef={refs.current["email"]}
            />
          </CustomSection>

          <CustomSection title="財務・取引情報">
            <Field
              name="feeRate"
              as={TextField}
              label="手数料率"
              error={touched.feeRate && Boolean(errors.feeRate)}
              helperText={touched.feeRate && errors.feeRate}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleChange}
              id={`field-fee_rate`}
              sx={{ width: 150 }}
              inputRef={refs.current["feeRate"]}
              placeholder="数値と「.」のみ"
            />
            <Field
              name="shippingFee"
              as={TextField}
              label="運賃"
              error={touched.shippingFee && Boolean(errors.shippingFee)}
              helperText={touched.shippingFee && errors.shippingFee}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleChange}
              id={`field-shipping_fee`}
              sx={{ width: 150 }}
              inputRef={refs.current["shippingFee"]}
              placeholder="数値と「.」のみ"
            />
            {/* <Field
              name="paymentFeeId"
              as={TextField}
              label="送金手数料コード"
              error={touched.paymentFeeId && Boolean(errors.paymentFeeId)}
              helperText={touched.paymentFeeId && errors.paymentFeeId}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleChange}
              id={`field-payment_fee_id`}
              sx={{ width: 150 }}
              inputRef={refs.current["paymentFeeId"]}
            /> */}
          </CustomSection>

          <CustomSection title="業務管理">
            <Field
              name="salesRecordTypeCd"
              as={SalesRecordTypeSelect}
              onChange={handleChange}
              label="原票種別"
              id={`field-sales_record_type_cd`}
              sx={{ width: 150 }}
              inputRef={refs.current["salesRecordTypeCd"]}
              moveNext={refs.current.moveNext}
            />
            <Field
              name="commodityOwnerTotalDivisionCd"
              as={CommodityOwnerTotalDivisionSelect}
              label="荷主集計区分"
              onChange={handleChange}
              id={`field-commodity_owner_total_division_cd`}
              sx={{ width: 150 }}
              inputRef={refs.current["commodityOwnerTotalDivisionCd"]}
            />
            <Field
              name="areaCd"
              as={AreaCdSelect}
              label="地区"
              onChange={handleChange}
              id={`area_cd`}
              sx={{ width: 150 }}
              inputRef={refs.current["areaCd"]}
            />
            <Field
              name="jaCode"
              as={TextField}
              label="農協コード"
              error={touched.jaCode && Boolean(errors.jaCode)}
              helperText={touched.jaCode && errors.jaCode}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleChange}
              id={`field-ja_code`}
              sx={{ width: 150 }}
              inputRef={refs.current["jaCode"]}
              placeholder="数値のみ"
            />
            <Field
              name="relatedGroupName"
              as={TextField}
              label="系統団体名"
              error={
                touched.relatedGroupName && Boolean(errors.relatedGroupName)
              }
              helperText={touched.relatedGroupName && errors.relatedGroupName}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleChange}
              id={`field-related_group_name`}
              sx={{ width: 300 }}
              inputRef={refs.current["relatedGroupName"]}
            />
            <Field
              name="closingDateGroupCd"
              as={ClosingDateGroupSelect}
              label="締日グループ"
              onChange={handleChange}
              id={`field-closing_date_group_cd`}
              sx={{ width: 150 }}
              inputRef={refs.current["closingDateGroupCd"]}
            />
            <Field
              name="balanceAccountCd"
              as={TextField}
              label="帳合先コード"
              error={
                touched.balanceAccountCd && Boolean(errors.balanceAccountCd)
              }
              helperText={touched.balanceAccountCd && errors.balanceAccountCd}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleChange}
              id={`field-balance_account_cd`}
              sx={{ width: 150 }}
              inputRef={refs.current["balanceAccountCd"]}
            />
          </CustomSection>

          {/* BankInfo */}
          <CustomSection title="金融機関情報">
            <Field
              name="bankAccountId"
              as={TextField}
              label="金融機関口座ID"
              error={touched.bankAccountId && Boolean(errors.bankAccountId)}
              helperText={touched.bankAccountId && errors.bankAccountId}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              id={`financial-field-bank-account-id`}
              sx={{ width: 150, display: "none" }}
              inputRef={refs.current["bankAccountId"]}
            />
            <Field
              name="bankCd"
              as={BankSelect}
              label="金融機関コード"
              onChange={handleChange}
              id={`financial-field-bank_cd`}
              sx={{ width: 250 }}
              moveNext={refs.current.moveNext}
              inputRef={refs.current["bankCd"]}
            />
            <Field
              name="bankBranchCd"
              as={BankBranchSelect}
              label="金融機関支店"
              onChange={handleChange}
              id={`financial-field-bank_branch_cd`}
              sx={{ width: 250 }}
              moveNext={refs.current.moveNext}
              inputRef={refs.current["bankBranchCd"]}
            />
            <Field
              name="accountTypeCd"
              as={AccountTypeSelect}
              label="口座区分"
              onChange={handleChange}
              id={`financial-field-account_type_cd`}
              sx={{ width: 100 }}
              moveNext={refs.current.moveNext}
              inputRef={refs.current["accountTypeCd"]}
            />
            <Field
              name="accountNumber"
              as={TextField}
              label="口座番号"
              error={touched.accountNumber && Boolean(errors.accountNumber)}
              helperText={touched.accountNumber && errors.accountNumber}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ width: 150 }}
              id={`financial-field-account_number`}
              inputRef={refs.current["accountNumber"]}
              placeholder="数値のみ"
            />
            <Field
              name="accountName"
              as={TextField}
              label="名義"
              error={touched.accountName && Boolean(errors.accountName)}
              helperText={touched.accountName && errors.accountName}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ width: 350 }}
              id={`financial-field-account_name`}
              inputRef={refs.current["accountName"]}
            />
            <Button
              variant="outlined"
              onClick={() => clearBankInfo(setFieldValue)}
            >
              クリア
            </Button>
          </CustomSection>

          {/* invoiceRegistrationInfo */}
          <CustomSection title="課税期間情報">
            <Box>
            <Field
              name="businessRegistrationNo"
              as={TextField}
              label="事業者登録番号"
              error={
                touched.businessRegistrationNo &&
                Boolean(errors.businessRegistrationNo)
              }
              helperText={
                touched.businessRegistrationNo && errors.businessRegistrationNo
              }
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleChange}
              id={`field-business_registration_no`}
              sx={{ width: 250, display:"block", marginBottom: 1 }}
              inputRef={refs.current["businessRegistrationNo"]}
            />
            
            <InvoiceRegistrationHistoryForm
              values={values}
              handleChange={handleChange}
              errors={errors.invoiceRegistrationHistoryList}
              setFieldValue={setFieldValue}
              refs={refs}
            />
            </Box>
          </CustomSection>
        </Form>
      )}
    </Formik>
  );
};

export default CommodityOwnerNewForm;
